import i from"styled-components";import{theme as o}from"../../../../theme.js";const e=i.h1`
  margin: 0;
  color: ${o.colors.gray[900]};
  font-weight: 700;
  font-size: 24px;
  @media screen and (max-width: ${o.breakpoints.md}) {
    font-size: 20px;
  }
`,n=i.button`
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  background-color: transparent;
  transition: all .1s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${o.colors.gray[400]}
    }
  }
  &:hover {
    background-color: ${o.colors.gray[200]};
    > svg {
      > g, path {
        fill: ${o.colors.gray[500]};
      }
    }
  }
`,t=i.div`
  position: sticky;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  padding: ${o.spacing*4}px;
  box-sizing: border-box;
  background-color: ${o.colors.shades[0]};
  .desktop, .mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${o.spacing*2}px;
    > div {
      display: flex;
      align-items: center;
      gap: ${o.spacing*2}px;
    }
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    position: fixed;
    padding: ${o.spacing*2}px;
    box-shadow: ${o.boxShadow};
    .mobile {
      display: flex;
    }
    .desktop {
      display: none;
    }
  }
`;export{t as Container,n as Icon,e as Title};
